document.addEventListener('change', event => {
  if (event.target.matches('input.product-compare-checkbox[type="checkbox"][data-variant-id]')) {
    const variantId = event.target.dataset.variantId;
    const isChecked = event.target.checked;
    
    const cookies = document.cookie.split(';').reduce((cookies, cookie) => {
      const [name, value] = cookie.split('=').map(c => c.trim());
      cookies[name] = value;
      return cookies;
    }, {})
    
    let compareItems = [];
    if (cookies.compareItems) {
      try {
        compareItems = JSON.parse(decodeURIComponent(cookies.compareItems));
      } catch (e) {
        console.error('Error parsing compareItems cookie', e);
      }
    }

    let warningTimeout = null;

    if (isChecked) {
      console.log(compareItems.length)
      if (compareItems.length >= 4) {
        event.target.checked = false;
        const checkboxBtn = event.target.closest('.product-compare-btn');       
        const oldWarning = checkboxBtn.querySelector('.product-compare-warning');
        if (oldWarning) oldWarning.remove();
        
        if (warningTimeout) clearTimeout(warningTimeout);       
        checkboxBtn.insertAdjacentHTML('afterbegin', '<div class="product-compare-warning">You can add a maximum of 4 products</div>');    
        warningTimeout = setTimeout(() => {
          const existingWarning = checkboxBtn.querySelector('.product-compare-warning');
          if (existingWarning) {
            existingWarning.classList.add('fade-out');
            setTimeout(() => existingWarning.remove(), 500);
          }
        }, 5000);        
        return;
      }
      if (!compareItems.includes(variantId)) {
        compareItems.push(variantId);
      }
    } else {
      compareItems = compareItems.filter(id => id !== variantId);
    }
    
    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    document.cookie = `compareItems=${encodeURIComponent(JSON.stringify(compareItems))}; expires=${date.toUTCString()}; path=/`;
    compareProducts()
  }
})

function checkCompareCheckboxes() {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + 'compareItems'.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    const compareItemsCookie = matches ? decodeURIComponent(matches[1]) : undefined;
    
    if (compareItemsCookie) {
        try {
            const compareItems = JSON.parse(compareItemsCookie);
            
            if (Array.isArray(compareItems) && compareItems.length > 0) {
                const checkboxes = document.querySelectorAll('input.product-compare-checkbox[type="checkbox"][data-variant-id]');
                
                checkboxes.forEach(checkbox => {
                    const variantId = checkbox.dataset.variantId;
                    if (compareItems.includes(variantId)) {
                        checkbox.checked = true;
                    }
                });
            }
        } catch (e) {
            console.error('Error parsing compareItems cookie:', e)
        }
    }
}

const observerCompare = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.matches('input.product-compare-checkbox[type="checkbox"][data-variant-id]')) {
                checkCompareCheckboxes();
                return;
            }
            
            if (node.nodeType === 1 && node.querySelectorAll) {
                const elements = node.querySelectorAll('input.product-compare-checkbox[type="checkbox"][data-variant-id]');
                if (elements.length > 0) {
                    checkCompareCheckboxes();
                    return;
                }
            }
        });
    });
});

observerCompare.observe(document.body, {
    childList: true,
    subtree: true
});

async function getProductForCompare() {
    const cookies = document.cookie.split(";");
    let compareItemsCookie = cookies.find((cookie) => cookie.trim().startsWith("compareItems="));

    if (!compareItemsCookie) {
        return { success: false, error: "No compareItems cookie found" };
    }

    const cookieValue = compareItemsCookie.split("=")[1];
    let productIds;

    try {
        productIds = JSON.parse(decodeURIComponent(cookieValue));
        if (!Array.isArray(productIds)) {
            return { success: false, error: "compareItems cookie is not an array" };
        }
    } catch (e) {
        return { success: false, error: "Failed to parse compareItems cookie" };
    }

    if (productIds.length === 0) {
        return { success: true, products: [] };
    }

    const graphQLQuery = `
    query GetProducts($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          title
          handle
          featuredImage {
            url
            altText
          }
          collections(first: 1) {
            edges {
              node {
                title
                handle
              }
            }
          }
        }
      }
    }
  `;

    try {
        let response = await fetch("/api/2024-01/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": "bbd28e36aef8e7be2c86256244b13bc8",
            },
            body: JSON.stringify({
                query: graphQLQuery,
                variables: {
                    ids: productIds.map((id) => `gid://shopify/Product/${id}`),
                },
            }),
        });

        let result = await response.json();

        function formatMetaKeyToCaption(key) {
            return key.replace(/_/g, " ").replace(/(?:^|\s)\S/g, (match) => match.toUpperCase());
        }

        const products = result.data.nodes
            .filter((product) => product !== null)
            .map((product) => ({
                id: product.id.split("/").pop(),
                title: product.title,
                url: `/products/${product.handle}`,
                image: product.featuredImage || null,
                collection: product.collections?.edges[0]?.node
                    ? {
                          title: product.collections.edges[0].node.title,
                          url: `/collections/${product.collections.edges[0].node.handle}`,
                      }
                    : null,
            }));

        return { success: true, products };
    } catch (error) {
        console.error("Error: ", error);
        return {
            error: "Request failed",
            details: error.message,
        };
    }
}

function compareProducts() {
    getProductForCompare().then((result) => {
        console.log(result.success);
        if (result.success) {
            let floatElement = document.querySelector('.product-compare-float');
            
            if (!floatElement) {
                floatElement = document.createElement('a');
                floatElement.href = "/pages/product-comparison";
                floatElement.className = "product-compare-float";
                floatElement.innerHTML = '<div class="product-compare-float--text">Compare</div>';
                document.body.appendChild(floatElement);
            }
            
            const qtyElement = floatElement.querySelector('.product-compare-float--qty');
            
            if (result.products?.length > 0) {
                if (!qtyElement) {
                    const newQtyElement = document.createElement('div');
                    newQtyElement.className = 'product-compare-float--qty';
                    newQtyElement.innerHTML = result.products.length;
                    floatElement.appendChild(newQtyElement);
                } else {
                    qtyElement.innerHTML = result.products.length;
                }
            } else if (qtyElement) {
                qtyElement.remove();
            }
        } else {
            if (result.error) {
                console.error(result.error);
            }
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
  checkCompareCheckboxes()
  compareProducts()
})